export default __webpack_public_path__ + "static/media/m_cycles1_eng.7f9fb296.png";